import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import styles from "./styles";
import LuvitComponent from "LuvitComponent";
import { Movable, MovableGrip } from "./movable";
import { autobind } from "lib/decorators";
import { Clear as ClearIcon } from "Components/Icons";

@autobind
class LuvitMovableSkyLight extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "Common");

    this.state = {
      isVisible: false,
      useProps: "isVisible" in this.props,
      previousElement: null,
    };
  }

  componentWillUpdate(nextProps, nextState) {
    let next = nextState,
      prev = this.state;
    if (this.state.useProps) {
      next = nextProps;
      prev = this.props;
    }

    if (next.isVisible && !prev.isVisible && this.props.beforeOpen) {
      this.props.beforeOpen();
    }

    if (!next.isVisible && prev.isVisible && this.props.beforeClose) {
      this.props.beforeClose();
    }
  }

  componentDidMount() {
    this.setState({ previousElement: document.activeElement });
    window.setTimeout(() => {
      if (ReactDOM.findDOMNode(this.refs.modalWrapper)) {
        ReactDOM.findDOMNode(this.refs.modalWrapper).focus();
      }
    }, 20);
  }

  componentWillUnmount() {
    this.state.previousElement.focus();
    this.setState({ previousElement: null });
    document.querySelector("html").style.overflowY = "auto";
  }

  componentDidUpdate(prevProps, prevState) {
    let next = this.state,
      prev = prevState;
    if (this.state.useProps) {
      next = this.props;
      prev = prevProps;
    }

    if (!prev.isVisible && next.isVisible && this.props.afterOpen) {
      this.props.afterOpen();
    }

    if (prev.isVisible && !next.isVisible && this.props.afterClose) {
      this.props.afterClose();
    }
  }

  close() {
    this.state.previousElement.focus();
    this.setState({ previousElement: null });
    this.props?.close();
  }

  show() {
    this.setState({ isVisible: true });
  }

  hide() {
    this.setState({ isVisible: false });
    document.querySelector("html").style.overflowY = "auto";
  }

  onModalWrapperClicked(evt) {
    if (!evt.target?.classList?.contains("movablemodal-body-wrapper")) {
      return;
    }
    this.onOverlayClicked();
  }

  onOverlayClicked() {
    if (this.props.hideOnOverlayClicked) {
      this.close();
      if (this.props.onOverlayClicked) {
        this.props.onOverlayClicked();
      }
    }

    if (this.props.onOverlayClicked) {
      this.props.onOverlayClicked();
    }
  }

  doRender() {
    let state = this.state.useProps ? this.props : this.state;
    var overlay;

    var dialogStyles = Object.assign(
      {},
      styles.dialogStyles,
      this.props.dialogStyles,
    );
    var overlayStyles = Object.assign(
      {},
      styles.overlayStyles,
      this.props.overlayStyles,
    );
    var closeButtonStyle = Object.assign(
      {},
      styles.closeButtonStyle,
      this.props.closeButtonStyle,
    );
    var titleStyle = Object.assign({}, styles.title, this.props.titleStyle);

    if (matchMedia) {
      if (window.matchMedia("( max-width:768px)").matches) {
        dialogStyles = {
          position: "fixed",
          height: "auto",
          minHeight: "100vh",
          margin: 0,
          top: "0px",
          overflowY: "auto",
          movable: false,
          zIndex: 1001,
          borderBottom: "2px",
        };
      }
    }

    overlayStyles.display = "block";
    dialogStyles.display = "block";
    !this.props.keepWindowScroll &&
      (document.querySelector("html").style.overflowY = "hidden");

    if (this.props.showOverlay) {
      overlay = (
        <div
          onClick={() => this.onOverlayClicked()}
          style={overlayStyles}
          className="movablemodal-overlay"
        />
      );
      var win = luvit.getLuvitTopPage();
      //        $(win.document).find("body").append('<div class="luvitdialog-overlay"></div>');
    }

    //fix for IOS11 https://hackernoon.com/how-to-fix-the-ios-11-input-element-in-fixed-modals-bug-aaf66c7ba3f8, https://stackoverflow.com/questions/46339063/ios-11-safari-bootstrap-modal-text-area-outside-of-cursor/46367269
    if (
      luvit.mqMobile.matches &&
      (luvit.matchAgent("iPad") || luvit.matchAgent("iPhone"))
    ) {
      dialogStyles.position = "absolute";
      overlayStyles.backgroundColor = "#fff";
      scrollTo(body, 0);
    }

    var icon = <span className="hidden" />;

    if (this.props.type) {
      icon = <span className={"icon-" + this.props.type} />;
    }
    return (
      <section className="movablemodal-wrapper">
        {overlay}
        <div
          ref={this.props.modalWrapperRef || "modalWrapper"}
          onClick={this.onModalWrapperClicked}
          className="movablemodal movablemodal-body-wrapper animated fadeInDown"
          style={dialogStyles}
          tabIndex="0"
        >
          <Movable enabled={this.props.movable !== false}>
            <div
              className="movablemodal-body"
              tabIndex="0"
              style={this.props.modalStyles}
              role="dialog"
              aria-describedby={this.l("movablemodal-content")}
              aria-labelledby={this.l("dialoguebox") + ": " + this.props.title}
            >
              <MovableGrip>
                <div ref="modalContent" className="movablemodal-title">
                  <h2 style={{ marginTop: 0, marginBottom: 0, ...titleStyle }}>
                    {this.props.title && (
                      <span>
                        {icon} {this.props.title}
                      </span>
                    )}
                  </h2>
                  <button
                    onClick={() => this.close()}
                    role="button"
                    title={this.l("close")}
                    style={closeButtonStyle}
                    className="button-transparent movablemodal-close"
                  >
                    <span className="sr-only">{this.l("close")}</span>
                    <div className="flex flex-center" aria-hidden="true">
                      {<ClearIcon />}
                    </div>
                  </button>
                </div>
              </MovableGrip>
              <div className="movablemodal-content">{this.props.children}</div>
            </div>
          </Movable>
        </div>
      </section>
    );
  }
}

LuvitMovableSkyLight.displayName = "LuvitMovableSkyLight";

LuvitMovableSkyLight.propTypes = {
  afterClose: PropTypes.func,
  afterOpen: PropTypes.func,
  beforeClose: PropTypes.func,
  beforeOpen: PropTypes.func,
  closeButtonStyle: PropTypes.object,
  dialogStyles: PropTypes.object,
  hideOnOverlayClicked: PropTypes.bool,
  onOverlayClicked: PropTypes.func,
  overlayStyles: PropTypes.object,
  showOverlay: PropTypes.bool,
  title: PropTypes.string,
  titleStyle: PropTypes.object,
};

LuvitMovableSkyLight.defaultProps = {
  title: "",
  showOverlay: true,
  overlayStyles: styles.overlayStyles,
  dialogStyles: styles.dialogStyles,
  closeButtonStyle: styles.closeButtonStyle,
  hideOnOverlayClicked: false,
};

export default LuvitMovableSkyLight;
